import React from "react";

function ListHeader(props) {
    return (
        <thead className="table-dark">
        <tr>
            {props.headers.map((header, index) => (
                <th key={index}>{header}</th>
            ))}
        </tr>
        </thead>
    )
}

export default ListHeader
